import React from 'react';
import styled, { keyframes } from 'styled-components';

const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
`;

const HeaderContainer = styled.div`
  text-align: center;
  padding: 30px 20px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-bottom: 3px solid rgba(255, 255, 255, 0.3);
  animation: ${bounce} 2s ease-in-out infinite;
`;

const Title = styled.h1`
  font-size: 3.5em;
  color: #fff;
  text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.3);
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 2.5em;
  }

  @media (max-width: 480px) {
    font-size: 2em;
  }
`;

const Subtitle = styled.div`
  font-size: 1.5em;
  color: #ffe066;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  animation: ${pulse} 2s ease-in-out infinite;

  @media (max-width: 768px) {
    font-size: 1.2em;
  }

  @media (max-width: 480px) {
    font-size: 1em;
  }
`;

function Header() {
  return (
    <HeaderContainer>
      <Title>🎉 STEVEN FROLKE 🎉</Title>
      <Subtitle>✨ MASTER JOURNALIST EXTRAORDINAIRE ✨</Subtitle>
    </HeaderContainer>
  );
}

export default Header;
